module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" version=\"1\" viewBox=\"0 0 1024 1024\"><path fill=\"#333\" d=\"M673 566a464 464 0 0 0 216-341c19 21 30 49 30 79v416c0 27-9 52-24 72L673 566zm-159-13c-170 0-310-160-328-367h657c-18 207-158 367-329 367zm-155 9L130 793c-15-20-25-45-25-73V304c0-38 17-71 45-93a472 472 0 0 0 209 351zm161 45c44 0 86-9 125-27l229 233c-20 15-44 25-71 25H221c-26 0-50-9-70-24l235-238c41 20 87 31 134 31z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/svg/email.svg
// module id = 188
// module chunks = 0